import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';

import Moment from 'moment';
import Translate from 'components/translate';
import TableList from 'components/TableList';

import SetNewOwnership from './lot-view-ownership-info-set-new-owner';
import SetNewTenancy from './lot-view-ownership-info-set-new-tenancy';
import EditCurrentOwnership from './lot-view-ownership-info-edit';

import { AppSettings } from '../../constants';

import * as LotActionType from '../constants';

class OwnershipInfo extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    LotProfile: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.queryParams = new URLSearchParams(this.props.location.search);
    this.state = {
      mode: this.queryParams.get('action'),
      isCheckedContact: props.LotProfile.isTenancyContact
    };
  }

  componentWillReceiveProps(nextProps) {
    const queryParams = new URLSearchParams(nextProps.location.search);
    this.setState({
      mode: queryParams.get('action'),
      isCheckedContact: nextProps.LotProfile.isTenancyContact
    });
  }

  onClickSetNewOwnership = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(this.props.location.pathname + `?active=${queryParams.get('active')}&action=add`);
  }

  onClickEditCurrentOwnership = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(this.props.location.pathname + `?active=${queryParams.get('active')}&action=edit`);
  }

  onClickSetNewTenancy = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(this.props.location.pathname + `?active=${queryParams.get('active')}&action=add-tenancy`);
  }

  onClickRemoveTenancy = (tenancyId) => {
    this.props.dispatch({
      type: LotActionType.REMOVE_TENANCY_ASYNC,
      params: {
        id: this.props.LotProfile.id,
        tenancyId
      }
    });
  }

  onCheckedContact = (e, data, status) => {
    this.setState({
      isCheckedContact: status.checked
    });
    this.props.dispatch({
      type: LotActionType.SET_LOT_PRIMARY_CONTACT_ASYNC,
      params: {
        id: this.props.LotProfile.id,
        isTenancyContact: status.checked
      }
    });
  }

  customRenderPurchaseDate = (item) => {
    return <span>{item.purchaseDate ? Moment(item.purchaseDate).format('MM/DD/YYYY') : '-'}</span>;
  }

  customRenderName = (item) => {
    return <span>{item.homeownerFullName}</span>;
  }

  customRenderEmail = (item) => {
    return <span>{item.homeowner.email}</span>;
  }

  customRenderStatus = (item) => {
    return <span>{item.status === 0 ? 'Former' : 'Current'}</span>;
  }

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='primary owner'>
        <span>Primary owner</span>
      </Tooltip>
    );
  }

  renderNotHasHomeowner = () => {
    return (
      <div className='lot-manage-ownership-info'>
        <ul className='nav nav-tabs wo-tab'>
          <li className='active'>
            <Link to={'#'}><Translate translateKey='homeowner' capitalize plurals /></Link>
          </li>
        </ul>
        <div className='row' style={{}}>
          <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Current owner(s)</div>
          <div className='col-md-6 col-sm-6'><strong style={{opacity: 0.5}}>(Not specified)</strong></div>
        </div>
        {AppSettings.clientTypeValue !== 'Homeowner' &&
        <button
          className='btn btn-primary btn-info btn-siteone btn-icon'
          onClick={this.onClickSetNewOwnership}
          style={{margin: '20px 20px 0 20px'}}>Set new ownership
        </button>
        }
      </div>
    );
  }

  renderTenant = () => {
    const { lotTenancies, lotOwnerships } = this.props.LotProfile;
    return (
      <div className='lot-manage-ownership-info' style={{marginTop: 35}}>
        <ul className='nav nav-tabs wo-tab'>
          <li className='active'>
            <Link to={'#'}>Tenants</Link>
          </li>
        </ul>
        {(lotTenancies && lotTenancies.length)
          ? (
            <React.Fragment>
              <div className='row' style={{marginBottom: 16}}>
                <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Current tenant</div>
                <div className='col-md-6 col-sm-6'>
                  <span style={{fontWeight: 600}}>
                    {lotTenancies[0].tenancy.displayName} <span style={{fontWeight: 400}}>({lotTenancies[0].tenancy.email})</span>
                  </span>
                </div>
              </div>
              <div className='row' style={{marginBottom: 20}}>
                <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Move in date</div>
                <div className='col-md-6 col-sm-6'>
                  {Moment(lotTenancies[0].moveInDate).format('MM/DD/YYYY')}
                </div>
              </div>

              <div>
                <div className='row'>
                  <div className='col-md-12 col-sm-12' style={{marginLeft: 20}}>
                    <CheckBoxSingle
                      style={{marginTop: -8}}
                      checked={this.state.isCheckedContact}
                      ref={c => { this.check = c; }}
                      onChecked={this.onCheckedContact}
                      value='contact'
                      name='ownerOccupied'
                      label='Tenant is the primary contact for work orders'
                      className='checkbox-default noteTitle'
                    />
                  </div>
                </div>
                <button
                  className='btn btn-primary btn-info btn-siteone-default btn-icon'
                  onClick={() => this.onClickRemoveTenancy(lotTenancies[0].tenancy.id)}
                  style={{margin: '0 20px'}}>Remove
                </button>
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div className='row' style={{marginBottom: 16}}>
                <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Current tenant</div>
                <div className='col-md-6 col-sm-6'>
                  <span style={{ 'opacity': '.5' }}>(Not specified)</span>
                </div>
              </div>
              {lotOwnerships && lotOwnerships.length &&
              <div>
                <button
                  className='btn btn-primary btn-info btn-siteone'
                  onClick={this.onClickSetNewTenancy}
                  style={{margin: '0 20px'}}>Set new tenancy
                </button>
              </div>
              }
            </React.Fragment>
          )}

      </div>

    );
  }

  renderHasHomeowner = () => {
    const { lotOwnerships } = this.props.LotProfile;

    return (
      <div className='lot-manage-ownership-info'>
        <ul className='nav nav-tabs wo-tab'>
          <li className='active'>
            <Link to={'#'}><Translate translateKey='homeowner' capitalize plurals /></Link>
          </li>
        </ul>
        <div className='row' style={{marginBottom: 16}}>
          <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Current owner(s)</div>
          <div className='col-md-6 col-sm-6'>
            {lotOwnerships.map((item, index) => {
              return <span key={index} style={{fontWeight: 600}}>{item.homeownerFullName} <span style={{fontWeight: 400}}>({item.homeowner.email})</span>
                {item.isPrimary &&
                  <OverlayTrigger placement='top' overlay={this.toolTip()} delayHide={10} delayShow={500}>
                    <i className='pe-7s-key' style={{fontSize: 22, verticalAlign: 'middle', marginLeft: 10}} />
                  </OverlayTrigger>
                }<br />
              </span>;
            })}
          </div>
        </div>
        <div className='row' style={{marginBottom: 20}}>
          <div className='col-md-2 col-sm-3 lot-ownership-info__title'>Purchase date</div>
          <div className='col-md-6 col-sm-6'>
            {lotOwnerships[0].purchaseDate
              ? (<strong>{Moment(lotOwnerships[0].purchaseDate).format('MM/DD/YYYY')}</strong>) : (
                <span style={{ 'opacity': '.5' }}>(Not specified)</span>
              )}

          </div>
        </div>
        {AppSettings.clientTypeValue === 'Builder' &&
        <div>
          <button
            className='btn btn-primary btn-info btn-siteone btn-icon'
            onClick={this.onClickEditCurrentOwnership}
            style={{margin: '0 20px'}}>Edit current ownership
          </button>
          <button
            className='btn btn-primary btn-siteone btn-siteone-orange btn-icon'
            onClick={this.onClickSetNewOwnership}
            style={{margin: 0}}>Set new ownership
          </button>
        </div>
        }
      </div>

    );
  }

  renderHomeowner = () => {
    const { lotOwnerships } = this.props.LotProfile;
    if (lotOwnerships) {
      return this.renderHasHomeowner();
    } else {
      return this.renderNotHasHomeowner();
    }
  }

  renderOwnershipHistory = () => {
    let data = [];
    if (this.props.LotProfile.lotOwnerships && this.props.LotProfile.lotOwnerships.length) {
      data = [...data, ...this.props.LotProfile.lotOwnerships];
    }
    if (this.props.LotProfile.lotHistoryOwnerships && this.props.LotProfile.lotHistoryOwnerships.length) {
      data = [...data, ...this.props.LotProfile.lotHistoryOwnerships];
    }
    const column = [
      { field: 'homeowner.id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
      { field: 'purchaseDate', header: 'Purchase date', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderPurchaseDate.bind(this) },
      { field: 'homeownerFullName', header: 'Owner', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderName.bind(this) },
      { field: 'homeowner.email', header: 'Email address', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderEmail.bind(this) },
      { field: 'status', header: 'Status', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderStatus.bind(this) }
    ];
    const options = {
      defaultSortName: 'purchaseDate',
      defaultSortOrder: 'descending'
    };
    return <div className='ownership-history-wrapper'>
      <div className='page-title clearfix'>
        <p className='pull-left'>Ownership history</p>
      </div>
      <TableList
        column={column}
        defaultParams={options}
        data={data}
        options={options}
        pagination={false}
      />
    </div>;
  }

  renderOwnershipInfo = () => {
    if (AppSettings.clientTypeValue !== 'Homeowner') {
      return ([
        this.renderHomeowner(),
        this.renderTenant(),
        this.renderOwnershipHistory()
      ]);
    } else {
      return this.renderHomeowner();
    }
  }

  render() {
    if (this.state.mode === 'add') {
      return <SetNewOwnership
        location={this.props.location}
        history={this.props.history}
        lotProfile={this.props.LotProfile} />;
    } else if (this.state.mode === 'edit') {
      if (this.props.LotProfile && this.props.LotProfile.lotOwnerships) {
        return <EditCurrentOwnership
          location={this.props.location}
          history={this.props.history}
          lotProfile={this.props.LotProfile} />;
      }
      return this.renderOwnershipInfo();
    } else if (this.state.mode === 'add-tenancy') {
      return <SetNewTenancy
        location={this.props.location}
        history={this.props.history}
        lotProfile={this.props.LotProfile} />;
    } else {
      return this.renderOwnershipInfo();
    }
  }
}

const mapStateToProps = (state) => {
  return {
    LotProfile: state.LotStore.LotProfile
  };
};

export default connect(mapStateToProps)(OwnershipInfo);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-ownership-info.js